import styled from 'styled-components';
import { theme } from '../../../theme';

const { up, breakpoints } = theme;

export const DivContentWrapper = styled.div`
  max-height: calc(100vh - 135px);
  padding: 0 40px;
  overflow: auto;

  & > div {
    padding: 20px 0;
  }

  &.has-footer {
    max-height: calc(100vh - 210px);
  }
  &.has-filter {
    min-height: calc(100vh - 210px);
    overflow-x: hidden;
  }
  &.notification-drawer {
    min-height: calc(100vh - 165px);
    max-height: calc(100vh - 165px);

    ${up(breakpoints.lg)} {
      min-height: calc(100vh - 128px);
      max-height: calc(100vh - 128px);
    }
  }
  &.no-padding {
    padding: 0;
    & > div {
      padding: 0;
    }
  }
`;
